import styled from 'styled-components';

const LanguageContainer = styled.div`
    width: 100%;
    position: absolute;
    top: 0px;
    padding: 20px;

    display: flex;
    justify-content: flex-end;
`;

export default LanguageContainer;
